import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import PropTypes from 'prop-types';
import Sidebar from "./Sidebar";
import { Header } from "./Header";
import "../styles/Layout.css";

const AdminPanel = ({ user, token }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="app-container">
      <Sidebar
        user={user}
        token={token}
        isOpen={isSidebarOpen}
      />
      {isSidebarOpen && (
      <div 
        className="sidebar-overlay" 
        onClick={() => setIsSidebarOpen(false)}
      />
    )}
      <div className={`content-container ${isSidebarOpen ? "expanded" : "collapsed"}`}>
        <Header user={user} isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar} token={token} />
        <div
          className={`main-content ${isSidebarOpen ? "expanded" : "collapsed"}`}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

AdminPanel.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  token: PropTypes.string.isRequired,
};

export default AdminPanel;
